/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Toast_Expense_Sync_Confirm_ErrorInputs */

const vi_toast_expense_sync_confirm_error = /** @type {(inputs: Toast_Expense_Sync_Confirm_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Không tạo được khoản chi`)
};

/**

* @param {Toast_Expense_Sync_Confirm_ErrorInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const toast_expense_sync_confirm_error = /** @type {((inputs?: Toast_Expense_Sync_Confirm_ErrorInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Toast_Expense_Sync_Confirm_ErrorInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_toast_expense_sync_confirm_error(inputs)
});